import React from 'react';

import { isObjectWithNonNullableValues } from '@clearverify/utils';

import { useVerificationRequestQuery, VerificationRequestWhereUnique } from 'src/api';

export const useVerificationRequest = (filter: VerificationRequestWhereUnique, skip?: boolean) => {
  const { data, loading } = useVerificationRequestQuery({
    variables: {
      filter,
    },
    skip: skip || !isObjectWithNonNullableValues(filter),
  });

  const verificationRequest = React.useMemo(() => {
    return data?.verificationRequest;
  }, [data?.verificationRequest]);

  return {
    verificationRequest,
    loading,
  };
};
